import { makeStyles, createStyles } from "@material-ui/core";

const noWrap = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap" as const,
};

export const useIssueStyles = makeStyles((theme) =>
    createStyles({
        acknowledgedPrimaryRow: {
            marginBottom: theme.spacing(1),
            ...theme.typography.body2,
            ...noWrap,
            "&:hover": {
                "& $tooltip": {
                    visibility: "visible",
                },
            },
        },
        tooltip: {
            display: "block",
            position: "absolute",
            backgroundColor: "#dcdcdc",
            padding: theme.spacing(1),
            borderRadius: "4px",
            transform: "translate(50%, 0)",
            visibility: "hidden",
            "&:after": {
                content: "''",
                position: "absolute",
                bottom: "100%",
                left: "50%",
                marginLeft: "-5px",
                borderWidth: "5px",
                borderStyle: "solid",
                borderColor: "transparent transparent #dcdcdc transparent",
            },
        },
        acknowledgedSecondaryRow: {
            ...theme.typography.body2,
            ...noWrap,
        },
        acknowledgeButtonHasError: {
            outline: `1px solid ${theme.palette.error.main}`,
        },
        inactiveIssue: {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
        issueCell: {
            display: "flex",
            flexDirection: "column",
        },
        issueResolvedPrimaryRow: {
            color: "#28A745",
            marginTop: theme.spacing(1),
            ...noWrap,
            "& .svg-inline--fa, & .MuiTypography-root": {
                fontWeight: 500,
                verticalAlign: "middle",
                lineHeight: 1,
                marginRight: theme.spacing(0.5),
            },
        },
        issueResolvedPrimaryRowAlt: {
            color: theme.palette.warning.dark,
            marginTop: theme.spacing(1),
            ...noWrap,
            "& .svg-inline--fa, & .MuiTypography-root": {
                fontWeight: 500,
                verticalAlign: "middle",
                lineHeight: 1,
                marginRight: theme.spacing(0.5),
            },
        },
        issueResolvedCaption: {
            color: theme.palette.success.main,
        },
        issueResolvedAvatar: {
            backgroundColor: "#9b9b9b",
        },
    }),
);
